<template>
    <div class="registrationWrapper">
        <div class="container">
            <div class="whiteBG-wrap">
                <div class="row">                
                    <div class="col-xxl-8 col-xl-8 col-lg-8 col-md-7">
                        <div class="regForm-wrap">
                            <h2>Billing Address & Contact Information</h2>
                            <hr>
                            <billing-form />
                        </div>
                    </div>
                    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-5">
                        <billing-side-info />
                    </div>                    
                </div>
                <span class="procecss-title">Employer Registration</span>
            </div>
        </div>        
    </div>
</template>
<script>
import BillingForm from '../../components/Registration/BillingInfo/BillingForm.vue'
import BillingSideInfo from '../../components/Registration/BillingInfo/BillingSideInfo.vue'
export default {
    name: 'BillingInfo',
    components: {
        BillingForm,
        BillingSideInfo
    }
}
</script>
<style src="../../assets/css/group-registration.css"></style>